// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3liSh","icon":"SortAdornment_icon__wDcp9","up":"SortAdornment_up__1stoV","down":"SortAdornment_down__2iyX-","active":"SortAdornment_active__v-zgZ"};